const report_types = [
  { id: "region_wise", name: "Region wise" },
  { id: "area_wise", name: "Area wise" },
  { id: "territory_wise", name: "Territory wise" },
  { id: "agency_wise", name: "Agency wise" },
  { id: "ff_wise", name: "Field-force wise" },
  { id: "merchant_wise", name: "Merchant wise" },
];

const merchant_status = [
  { id: "ACTIVE", name: "Active" },
  { id: "INACTIVE", name: "Inactive" },
  { id: "DISCONTINUED", name: "Discontinued" },
];

const acquisition_filter_whitelist = [
  "year",
  "month",
  "regions",
  "areas",
  "territories",
  "agency",
];

const categorization_filter_whitelist = [
  "reg_start_date",
  "reg_end_date",
  "business_unit",
  "sub_unit",
  "regions",
  "areas",
  "status",
];

const filter_whitelist = {
  "": [
    "report_type",
    "transaction_date",

    "reg_start_date",
    "reg_end_date",
    "status",
  ],

  region_wise: [
    "report_type",
    "transaction_date",

    "regions",

    "reg_start_date",
    "reg_end_date",
    "status",
  ],
  area_wise: [
    "report_type",
    "transaction_date",

    "regions",
    "areas",

    "reg_start_date",
    "reg_end_date",
    "status",
  ],
  territory_wise: [
    "report_type",
    "transaction_date",

    "regions",
    "areas",
    "territories",

    "reg_start_date",
    "reg_end_date",
    "status",
  ],
  agency_wise: [
    "report_type",
    "transaction_date",

    "regions",
    "areas",
    "territories",
    "agency",

    "reg_start_date",
    "reg_end_date",
    "status",
  ],
  ff_wise: [
    "report_type",
    "transaction_date",

    "regions",
    "areas",
    "territories",
    "agency",
    "field_force",

    "reg_start_date",
    "reg_end_date",
    "status",
  ],
  merchant_wise: [
    "report_type",
    "transaction_date",

    "regions",
    "areas",
    "territories",
    "agency",
    "field_force",

    "reg_start_date",
    "reg_end_date",
    "status",
  ],
};

const months = [
  {
    name: "January",
    id: "01",
  },
  {
    id: "02",
    name: "February",
  },
  {
    id: "03",
    name: "March",
  },
  {
    id: "04",
    name: "April",
  },
  {
    id: "05",
    name: "May",
  },
  {
    id: "06",
    name: "June",
  },
  {
    id: "07",
    name: "July",
  },
  {
    id: "08",
    name: "August",
  },
  {
    id: "09",
    name: "September",
  },
  {
    id: "10",
    name: "October",
  },
  {
    id: "11",
    name: "November",
  },
  {
    id: "12",
    name: "December",
  },
];

export {
  report_types,
  merchant_status,
  filter_whitelist,
  acquisition_filter_whitelist,
  months,
  categorization_filter_whitelist,
};
